/**
 * 本文件可以用来集中管理项目代码所依赖的环境。
 * 内网开发、内网测试、预发、生产环境分别对应 dev, test, staging, prod.
 * 如果需要在本机上开发、调试、测试不同的环境，可以有如下两种办法来切换环境：
 * 1. 将`hostnameMap`中 `localhost` 对应的 `staging` 改为 'prod', 'test', 'dev' 中的任意一个。
 * 2. 改最后一行，例如改成 export default 'test'
 * 如果页面使用的是本机 ip 地址访问而非 localhost，那么建议修改 getEnv() 扩充 hostnameMap
 * 本地测试、开发、调试切换环境后不建议提交本文件。
 */

/** @typedef {'dev' | 'test' | 'staging' | 'prod'} ENV */

/**
 * @returns {ENV}
 */
export function getEnv() {
  const hostname = window.location.hostname
  /** @type {Map<string, ENV>} */
  const hostnameMap = new Map([
    ['localhost', 'dev'],
    ['192.168.1.172', 'staging'],

    ['webtest.sayyoo.cn', 'test'],
    ['webdev.sayyoo.cn', 'dev'],

    ['h5test.sayyoo.cn', 'staging'],
    ['116.62.166.134', 'staging'],
    ['ty.sayyoo.cn', 'staging'],

    ['h5.sayyoo.cn', 'prod'],
    ['120.55.42.62', 'prod'],
    ['ht.sayyoo.cn', 'prod'],
  ])
  return hostnameMap.has(hostname) ? hostnameMap.get(hostname) : 'dev'
}

export default getEnv()



// WEBPACK FOOTER //
// ./src/env.js